import { useState } from 'react';
import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { CalendarEventsViewAllCalendarEvents } from 'components/calendar';

import type { HomeModuleProps } from './Home';

const HomeCalendarEventsSelected = ({
  defaultTitle,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module || !module.events?.length) return null;

  const queryParams = `&id=${module.events.join(
    filterValuesSeparator
  )}&sortBy=queryIds`;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CalendarEventsViewAllCalendarEvents
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        queryParams={queryParams}
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeCalendarEventsSelected;
